import api from 'app/shared/utils/api';

// service
import appLogger from 'app/shared/loggers/appLogger';

const MarketingActions = {
    createMarketingLead({
        fullAddress,
        unit,
        marketingLeadType,
        email,
        utmSource,
        utmMedium,
        utmCampaign,
        utmContent,
    }) {
        return dispatch => dispatch(api.marketing.createMarketingLead({
            fullAddress,
            unit,
            marketingLeadType,
            email,
            utmSource,
            utmMedium,
            utmCampaign,
            utmContent,
        }))
            .catch((err) => {
                appLogger.logError({
                    message: err.message,
                    context: 'MarketingActions.createMarketingLead',
                });
            });
    },
};

export default MarketingActions;
